import { render, staticRenderFns } from "./PerformanceChangeInfo.vue?vue&type=template&id=d3622fd4&scoped=true&"
import script from "./PerformanceChangeInfo.vue?vue&type=script&lang=js&"
export * from "./PerformanceChangeInfo.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceChangeInfo.vue?vue&type=style&index=0&id=d3622fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3622fd4",
  null
  
)

export default component.exports